import { Link } from "react-router-dom";

function NotFoundPage() {
    return (
        <section className="text-center py-5">
            <h1 className="h3 mb-2">Page introuvable</h1>
            <p className="text-secondary mb-3">La route demandée n'existe pas.</p>
            <Link to="/" className="btn btn-outline-primary">Retour dashboard</Link>
        </section>
    );
}

export default NotFoundPage;
